const actionTypeIdentifier = '6706C9B8-6999-4ACB-AAB7-C83DCE46F27D';

export const setUnreadHeaderNotifications = `SET-UNREAD-HEADER-NOTIFICATION-${actionTypeIdentifier}`;
export const setHeaderNotifications = `SET-HEADER-NOTIFICATIONS-${actionTypeIdentifier}`;
export const setShowHeaderNotificationModal = `SET-SHOW-HEADER-NOTIFICATION-MODAL-${actionTypeIdentifier}`;
export const setMatchAuditErrorDetails = `SET-MATCH-AUDIT-ERROR-DETAILS-${actionTypeIdentifier}`;
export const setUploadErrorDetails = `SET-UPLOAD-ERROR-DETAILS-${actionTypeIdentifier}`;
export const setChargeMappingErrorDetails = `SET-CHARGE-MAPPING-ERROR-DETAILS-${actionTypeIdentifier}`;
export const setErrorDetaisLoading = `SET-ERROR-DETAILS-LOADING-${actionTypeIdentifier}`;